export default "__VITE_PUBLIC_ASSET__b0f454d5__"